export const PAISES_EIDU = [
  { label: "Costa Rica", value: "Costa Rica" },
  { label: "Colombia", value: "Colombia" },
  { label: "Afganistán", value: "Afganistán" },
  { label: "Albania", value: "Albania" },
  { label: "Alemania", value: "Alemania" },
  { label: "Andorra", value: "Andorra" },
  { label: "Angola", value: "Angola" },
  { label: "Antigua y Barbuda", value: "Antigua y Barbuda" },
  { label: "Arabia Saudita", value: "Arabia Saudita" },
  { label: "Argelia", value: "Argelia" },
  { label: "Argentina", value: "Argentina" },
  { label: "Armenia", value: "Armenia" },
  { label: "Australia", value: "Australia" },
  { label: "Austria", value: "Austria" },
  { label: "Azerbaiyán", value: "Azerbaiyán" },
  { label: "Bahamas", value: "Bahamas" },
  { label: "Bangladés", value: "Bangladés" },
  { label: "Barbados", value: "Barbados" },
  { label: "Baréin", value: "Baréin" },
  { label: "Belice", value: "Belice" },
  { label: "Benín", value: "Benín" },
  { label: "Bielorrusia", value: "Bielorrusia" },
  { label: "Birmania", value: "Birmania" },
  { label: "Bolivia", value: "Bolivia" },
  { label: "Bosnia y Herzegovina", value: "Bosnia y Herzegovina" },
  { label: "Botsuana", value: "Botsuana" },
  { label: "Brasil", value: "Brasil" },
  { label: "Brunéi", value: "Brunéi" },
  { label: "Bulgaria", value: "Bulgaria" },
  { label: "Burkina Faso", value: "Burkina Faso" },
  { label: "Burundi", value: "Burundi" },
  { label: "Bután", value: "Bután" },
  { label: "Bélgica", value: "Bélgica" },
  { label: "Cabo Verde", value: "Cabo Verde" },
  { label: "Camboya", value: "Camboya" },
  { label: "Camerún", value: "Camerún" },
  { label: "Canadá", value: "Canadá" },
  { label: "Catar", value: "Catar" },
  { label: "Chad", value: "Chad" },
  { label: "Chile", value: "Chile" },
  { label: "China", value: "China" },
  { label: "Chipre", value: "Chipre" },
  { label: "Ciudad del Vaticano", value: "Ciudad del Vaticano" },
  { label: "Comoras", value: "Comoras" },
  { label: "Congo", value: "Congo" },
  { label: "Corea del Norte", value: "Corea del Norte" },
  { label: "Corea del Sur", value: "Corea del Sur" },
  { label: "Costa de Marfil", value: "Costa de Marfil" },
  { label: "Croacia", value: "Croacia" },
  { label: "Cuba", value: "Cuba" },
  { label: "Dinamarca", value: "Dinamarca" },
  { label: "Dominica", value: "Dominica" },
  { label: "Ecuador", value: "Ecuador" },
  { label: "Egipto", value: "Egipto" },
  { label: "El Salvador", value: "El Salvador" },
  { label: "Emiratos Árabes Unidos", value: "Emiratos Árabes Unidos" },
  { label: "Eritrea", value: "Eritrea" },
  { label: "Eslovaquia", value: "Eslovaquia" },
  { label: "Eslovenia", value: "Eslovenia" },
  { label: "España", value: "España" },
  { label: "Estados Unidos", value: "Estados Unidos" },
  { label: "Estonia", value: "Estonia" },
  { label: "Etiopía", value: "Etiopía" },
  { label: "Filipinas", value: "Filipinas" },
  { label: "Finlandia", value: "Finlandia" },
  { label: "Fiyi", value: "Fiyi" },
  { label: "Francia", value: "Francia" },
  { label: "Gabón", value: "Gabón" },
  { label: "Gambia", value: "Gambia" },
  { label: "Georgia", value: "Georgia" },
  { label: "Ghana", value: "Ghana" },
  { label: "Granada", value: "Granada" },
  { label: "Grecia", value: "Grecia" },
  { label: "Guatemala", value: "Guatemala" },
  { label: "Guinea", value: "Guinea" },
  { label: "Guinea Ecuatorial", value: "Guinea Ecuatorial" },
  { label: "Guinea-Bisáu", value: "Guinea-Bisáu" },
  { label: "Guyana", value: "Guyana" },
  { label: "Haití", value: "Haití" },
  { label: "Honduras", value: "Honduras" },
  { label: "Hungría", value: "Hungría" },
  { label: "India", value: "India" },
  { label: "Indonesia", value: "Indonesia" },
  { label: "Irak", value: "Irak" },
  { label: "Irlanda", value: "Irlanda" },
  { label: "Irán", value: "Irán" },
  { label: "Islandia", value: "Islandia" },
  { label: "Islas Marshall", value: "Islas Marshall" },
  { label: "Islas Salomón", value: "Islas Salomón" },
  { label: "Israel", value: "Israel" },
  { label: "Italia", value: "Italia" },
  { label: "Jamaica", value: "Jamaica" },
  { label: "Japón", value: "Japón" },
  { label: "Jordania", value: "Jordania" },
  { label: "Kazajistán", value: "Kazajistán" },
  { label: "Kenia", value: "Kenia" },
  { label: "Kirguistán", value: "Kirguistán" },
  { label: "Kiribati", value: "Kiribati" },
  { label: "Kuwait", value: "Kuwait" },
  { label: "Laos", value: "Laos" },
  { label: "Lesoto", value: "Lesoto" },
  { label: "Letonia", value: "Letonia" },
  { label: "Liberia", value: "Liberia" },
  { label: "Libia", value: "Libia" },
  { label: "Liechtenstein", value: "Liechtenstein" },
  { label: "Lituania", value: "Lituania" },
  { label: "Luxemburgo", value: "Luxemburgo" },
  { label: "Líbano", value: "Líbano" },
  { label: "Macedonia del Norte", value: "Macedonia del Norte" },
  { label: "Madagascar", value: "Madagascar" },
  { label: "Malasia", value: "Malasia" },
  { label: "Malaui", value: "Malaui" },
  { label: "Maldivas", value: "Maldivas" },
  { label: "Malta", value: "Malta" },
  { label: "Malí", value: "Malí" },
  { label: "Marruecos", value: "Marruecos" },
  { label: "Mauricio", value: "Mauricio" },
  { label: "Mauritania", value: "Mauritania" },
  { label: "Micronesia", value: "Micronesia" },
  { label: "Moldavia", value: "Moldavia" },
  { label: "Mongolia", value: "Mongolia" },
  { label: "Montenegro", value: "Montenegro" },
  { label: "Mozambique", value: "Mozambique" },
  { label: "México", value: "México" },
  { label: "Mónaco", value: "Mónaco" },
  { label: "Namibia", value: "Namibia" },
  { label: "Nauru", value: "Nauru" },
  { label: "Nepal", value: "Nepal" },
  { label: "Nicaragua", value: "Nicaragua" },
  { label: "Nigeria", value: "Nigeria" },
  { label: "Noruega", value: "Noruega" },
  { label: "Nueva Zelanda", value: "Nueva Zelanda" },
  { label: "Níger", value: "Níger" },
  { label: "Omán", value: "Omán" },
  { label: "Pakistán", value: "Pakistán" },
  { label: "Palaos", value: "Palaos" },
  { label: "Palestina", value: "Palestina" },
  { label: "Panamá", value: "Panamá" },
  { label: "Papúa Nueva Guinea", value: "Papúa Nueva Guinea" },
  { label: "Paraguay", value: "Paraguay" },
  { label: "Países Bajos", value: "Países Bajos" },
  { label: "Perú", value: "Perú" },
  { label: "Polonia", value: "Polonia" },
  { label: "Portugal", value: "Portugal" },
  { label: "Puerto Rico", value: "Puerto Rico" },
  { label: "Reino Unido", value: "Reino Unido" },
  { label: "República Centroafricana", value: "República Centroafricana" },
  { label: "República Checa", value: "República Checa" },
  { label: "República Democrática del Congo", value: "República Democrática del Congo" },
  { label: "República Dominicana", value: "República Dominicana" },
  { label: "Ruanda", value: "Ruanda" },
  { label: "Rumania", value: "Rumania" },
  { label: "Rusia", value: "Rusia" },
  { label: "Samoa", value: "Samoa" },
  { label: "San Cristóbal y Nieves", value: "San Cristóbal y Nieves" },
  { label: "San Marino", value: "San Marino" },
  { label: "San Vicente y las Granadinas", value: "San Vicente y las Granadinas" },
  { label: "Santa Lucía", value: "Santa Lucía" },
  { label: "Santo Tomé y Príncipe", value: "Santo Tomé y Príncipe" },
  { label: "Senegal", value: "Senegal" },
  { label: "Serbia", value: "Serbia" },
  { label: "Seychelles", value: "Seychelles" },
  { label: "Sierra Leona", value: "Sierra Leona" },
  { label: "Singapur", value: "Singapur" },
  { label: "Siria", value: "Siria" },
  { label: "Somalia", value: "Somalia" },
  { label: "Sri Lanka", value: "Sri Lanka" },
  { label: "Suazilandia", value: "Suazilandia" },
  { label: "Sudáfrica", value: "Sudáfrica" },
  { label: "Sudán", value: "Sudán" },
  { label: "Sudán del Sur", value: "Sudán del Sur" },
  { label: "Suecia", value: "Suecia" },
  { label: "Suiza", value: "Suiza" },
  { label: "Surinam", value: "Surinam" },
  { label: "Tailandia", value: "Tailandia" },
  { label: "Tanzania", value: "Tanzania" },
  { label: "Tayikistán", value: "Tayikistán" },
  { label: "Timor Oriental", value: "Timor Oriental" },
  { label: "Togo", value: "Togo" },
  { label: "Tonga", value: "Tonga" },
  { label: "Trinidad y Tobago", value: "Trinidad y Tobago" },
  { label: "Turkmenistán", value: "Turkmenistán" },
  { label: "Turquía", value: "Turquía" },
  { label: "Tuvalu", value: "Tuvalu" },
  { label: "Túnez", value: "Túnez" },
  { label: "Ucrania", value: "Ucrania" },
  { label: "Uganda", value: "Uganda" },
  { label: "Uruguay", value: "Uruguay" },
  { label: "Uzbekistán", value: "Uzbekistán" },
  { label: "Vanuatu", value: "Vanuatu" },
  { label: "Venezuela", value: "Venezuela" },
  { label: "Vietnam", value: "Vietnam" },
  { label: "Yemen", value: "Yemen" },
  { label: "Yibuti", value: "Yibuti" },
  { label: "Zambia", value: "Zambia" },
  { label: "Zimbabue", value: "Zimbabue" },
  { label: "Otro", value: "Otro" },
];

/** Filtro de búsqueda sin acentos para el Select de países. */
export function filtrarPaisOpcion(input: string, option?: { label?: string; value?: string }) {
  const normalize = (value: string) =>
    value
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
  const needle = normalize(input || "");
  const haystack = normalize(String(option?.label ?? option?.value ?? ""));
  return haystack.includes(needle);
}

export function mapGruposToTalleresOptions(grupoSet: any[] = []) {
  return grupoSet.map((g) => ({
    label:
      g.cupoDisponible > 0
        ? `${g.nombre} (${g.cupoDisponible} cupos)`
        : `${g.nombre} (sin cupos)`,
    value: Number(g.id),
    disabled: g.cupoDisponible <= 0,
    cupoDisponible: g.cupoDisponible,
  }));
}

const INSTITUCIONES_EIDU_NOMBRES = [
  "Academia Diplomática Augusto Ramírez Ocampo",
  "Centro Universitario Tecnológico (CEUTEC)",
  "Instituto Federal de Pará",
  "NEUUNI",
  "Tecnológico de Costa Rica",
  "Universidad Alfonso X el Sabio",
  "Universidad Autónoma de Bucaramanga",
  "Universidad Autónoma de Coahuila",
  "Universidad Castro Carazo",
  "Universidad Católica de Costa Rica",
  "Universidad Cooperativa de Colombia",
  "Universidad de Cienfuegos «Carlos Rafael Rodríguez»",
  "Universidad de Costa Rica",
  "Universidad de Ibagué",
  "Universidad de la República",
  "Universidad de La Sabana",
  "Universidad de La Salle",
  "Universidad de Medellín",
  "Universidad de Santander",
  "Universidad del Rosario",
  "Universidad El Bosque",
  "Universidad Estatal a Distancia",
  "Universidad Industrial de Santander",
  "Universidad Interamericana de Puerto Rico, Recinto de Ponce",
  "Universidad José Cecilio del Valle",
  "Universidad Latinoamericana de Ciencia y Tecnología (ULACIT)",
  "Universidad Minuto de Dios (UNIMINUTO)",
  "Universidad Nacional de Costa Rica",
  "Universidad Nacional de Córdoba",
  "Universidad Pedagógica y Tecnológica de Colombia (UPTC)",
  "Universidad Pontificia Bolivariana",
  "Universidad Popular del Cesar",
  "Universidad Santa Paula",
  "Universidad Tecnológica Centroamericana",
  "Universidad Técnica Nacional",
  "Universidade Estadual Paulista",
  "Universitaria Agustiniana",
];

export const INSTITUCIONES_EIDU = [
  ...INSTITUCIONES_EIDU_NOMBRES.map((nombre) => ({
    label: nombre,
    value: nombre,
  })),
  { label: "Otro", value: "Otro" },
];

function parseUniversidad(universidad?: string | null) {
  if (!universidad) {
    return { pertenecienteA: undefined, pertenecienteAOtro: undefined };
  }
  if (universidad.startsWith("Otro:")) {
    return {
      pertenecienteA: "Otro",
      pertenecienteAOtro: universidad.replace(/^Otro:\s*/, ""),
    };
  }
  return { pertenecienteA: universidad, pertenecienteAOtro: undefined };
}

export function mapEiduFormValues(values: any, periodoMatriculaId: number) {
  const pertenecienteA =
    values.pertenecienteA === "Otro"
      ? `Otro: ${values.pertenecienteAOtro}`
      : values.pertenecienteA;

  const tallerId =
    values.taller != null && values.taller !== ""
      ? Number(values.taller)
      : null;

  return {
    tipo: 1,
    identificacion: String(values.identificacion ?? "").replace(/\D/g, ""),
    nombre: values.nombre,
    correoInstitucional: values.correoContacto,
    telefono: values.telefono,
    unidad: values.unidad,
    carrera: values.carrera,
    periodoMatricula: periodoMatriculaId,
    grupo: tallerId,
    universidad: pertenecienteA,
    pais: values.pais,
    tieneDiscapacidad: values.tieneDiscapacidad === "si",
    tipoDiscapacidad:
      values.tieneDiscapacidad === "si" && values.tipoDiscapacidad?.length
        ? values.tipoDiscapacidad.join(", ")
        : null,
    requiereApoyo: values.requiereApoyo === "si",
    detalleApoyo: values.requiereApoyo === "si" ? values.detalleApoyo : null,
  };
}

export function docenteToEiduInitialValues(
  docente: any,
  options?: { taller?: number; talleres?: number[] }
) {
  const { pertenecienteA, pertenecienteAOtro } = parseUniversidad(
    docente.universidad
  );

  return {
    correoContacto: docente.correoInstitucional,
    confirmacionCorreo: docente.correoInstitucional,
    nombre: docente.nombre,
    identificacion: docente.identificacion,
    pais: docente.pais ?? "",
    telefono: docente.telefono ?? "",
    pertenecienteA,
    pertenecienteAOtro,
    unidad: docente.unidad ?? "",
    carrera: docente.carrera ?? "",
    taller: options?.taller ?? options?.talleres?.[0],
    tieneDiscapacidad: docente.tieneDiscapacidad ? "si" : "no",
    tipoDiscapacidad:
      docente.tipoDiscapacidad?.split(", ").filter(Boolean) ?? [],
    requiereApoyo: docente.requiereApoyo ? "si" : "no",
    detalleApoyo: docente.detalleApoyo ?? "",
  };
}

export function mapEiduFormToEditValues(values: any, docenteId: number) {
  const base = mapEiduFormValues(values, 0);
  return {
    id: docenteId,
    tipo: base.tipo,
    identificacion: base.identificacion,
    nombre: base.nombre,
    correoInstitucional: base.correoInstitucional,
    telefono: base.telefono,
    unidad: base.unidad,
    carrera: base.carrera,
    universidad: base.universidad,
    pais: base.pais,
    tieneDiscapacidad: base.tieneDiscapacidad,
    tipoDiscapacidad: base.tipoDiscapacidad,
    requiereApoyo: base.requiereApoyo,
    detalleApoyo: base.detalleApoyo,
  };
}
